import { render, staticRenderFns } from "./ProductCategorySetting.vue?vue&type=template&id=47df9296&scoped=true"
import script from "./ProductCategorySetting.vue?vue&type=script&lang=js"
export * from "./ProductCategorySetting.vue?vue&type=script&lang=js"
import style0 from "./ProductCategorySetting.vue?vue&type=style&index=0&id=47df9296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47df9296",
  null
  
)

export default component.exports